export default {
  nav: {
    about: 'Sobre',
    shows: 'Eventos',
    music: 'Música',
    contact: 'Contato'
  },
  hero: {
    tagline: 'Músicas que criam memórias!',
    bookNow: 'Solicitar Orçamento',
    listen: 'Ouvir'
  },
  about: {
    title: 'Sobre',
    paragraph1: 'A proposta é transformar seu evento em uma experiência sonora inesquecível, focada na conexão, na energia e na emoção do momento. O set é construído em tempo real, sentindo o evento, a pista e o ritmo dos seus convidados.',
    paragraph2: 'Músicas com energia e sentimento, pesquisada, ouvida e escolhida para um público que vive e viveu o melhor de várias gerações. Trazer energia, nostalgia, modernidade, novidades e boa vibração — tudo na dosagem certa!',
    features: {
      curation: 'Curadoria em Tempo Real',
      curationDesc: 'O set é guiado pela vibe e a atmosfera do local',
      collaboration: 'Colaboração e Abertura',
      collaborationDesc: 'Pedidos e sugestões são acolhidos',
      respect: 'Respeito Atemporal',
      respectDesc: 'Todas as idades terão seu espaço',
      professionalism: 'Simplicidade e Profissionalismo',
      professionalismDesc: 'Equipamento de som completo'
    },
    stats: {
      events: 'Eventos',
      years: 'Anos',
      satisfaction: 'Satisfação'
    }
  },
  shows: {
    title: 'Próximos Eventos',
    subtitle: 'Confira onde estarei tocando',
    getTickets: 'Mais Info'
  },
  music: {
    title: 'Estilo Musical',
    subtitle: 'Set em tempo real, sentindo o clima',
    genres: {
      hits: 'Hits & Funk',
      world: 'Músicas do mundo',
      rock: 'Rock & Flashback',
      dance: 'Dance & Eletrônica'
    },
    quote: 'Trabalho feito com o coração, especialmente para um público que viveu muita coisa boa... e ainda quer viver muito mais'
  },
  contact: {
    title: 'Vamos Criar Sua Próxima Memória?',
    subtitle: 'Solicite um orçamento personalizado e eleve o nível do seu evento',
    namePlaceholder: 'Nome',
    emailPlaceholder: 'E-mail',
    phonePlaceholder: 'Telefone',
    locationPlaceholder: 'Local do Evento',
    messagePlaceholder: 'Conte sobre seu evento...',
    sendButton: 'Solicitar Orçamento',
    successMessage: 'Solicitação enviada com sucesso! Entrarei em contato em breve.',
    errorMessage: 'Erro ao enviar solicitação. Tente novamente ou entre em contato diretamente.'
  },
  footer: {
    rights: 'Todos os direitos reservados',
    tagline: 'Porque a música certa emociona. Conecta. Transforma.',
    devBy: 'Desenvolvido por'
  }
}
